<template>
  <div class="mb-5">
    <h4>Create Chat Flows</h4>
    <img
      src="/assets/img/covid19tracker/3-create-new-chat.PNG"
      alt="Create new chat"
      class="img-fluid my-3"
    />
    <p>
      In this page your bot's complete functionality is defined in the form of Chats and Triggers.
      If you have not read about the Chats and Triggers,
      <a
        href="https://www.thebotcreator.com/user-guide"
        target="_blank"
      >click here to read user-guide.</a>
    </p>

    <p>Click on 'Create New Chat'</p>
    <img
      src="/assets/img/covid19tracker/4-add-event.PNG"
      alt="add new event"
      class="img-fluid my-3"
    />
    <p>Give a chat name as 'start' (it can be anything), we are going to link this chat with '/start' command. so whenever user sends '/start' command to bot, the bot will follow events present in this chat.</p>
    <p>Click on 'Add Event'</p>

    <img
      src="/assets/img/covid19tracker/5-add-new-task.PNG"
      alt="add new task"
      class="img-fluid my-3"
    />
    <p>You can have multiple tasks in an event. click on 'Add New Task'</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>